import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";
import "./style.css";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

const lookup = [
  {
    value: 0,
    text: "ЧЕРНОВИК"
  },
  {
    value: 1,
    text: "ИДЕТ НАБОР"
  },
  {
    value: 2,
    text: "ЗАПИСЬ ЗАКРЫТА"
  },
  {
    value: 3,
    text: "ЗАВЕРШЕНО"
  }
];

function masterClassStateExcelCell(options, column, gridCell) {
  if (gridCell.value === 0) {
    options.value = "ЧЕРНОВИК";
  } else if (gridCell.value === 1) {
    options.value = "ИДЕТ НАБОР";
  } else if (gridCell.value === 2) {
    options.value = "ЗАПИСЬ ЗАКРЫТА";
  } else if (gridCell.value === 3) {
    options.value = "ЗАВЕРШЕНО";
  }
}

function masterClassStateCell(config) {
  config.cellRender = MasterClassStateCell;
  config.dataType = "number";
  config.alignment = "center";
  config.lookup = {
    dataSource: lookup,
    valueExpr: "value",
    displayExpr: "text"
  }
}

const groupSateTextColor = {
  '0': "#778899",
  '1': "#007FBD",
  '2': "#F15454",
  '3': "#778899"
};

const MasterClassStateCell = (cellData) => {
  switch (cellData.value) {
    case 0:
      return (
        <div>
          <Tooltip title="ЧЕРНОВИК">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<EditOutlinedIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 1:
      return (
        <div>
          <Tooltip title="ИДЕТ НАБОР">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<AccessTimeIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 2:
      return (
        <div>
          <Tooltip title="ЗАПИСЬ ЗАКРЫТА">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<BlockIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 3:
      return (
        <div>
          <Tooltip title="ЗАВЕРШЕНО">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<CheckCircleOutlineIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    default:
      return null;
  }
};


export {masterClassStateCell, masterClassStateExcelCell}
